// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"cd125339","458":"93d088a4","570":"9035efc7","774":"1f1fc0bc","820":"2ec2de36","858":"d7b3ff46","904":"a7762461","910":"202927d3"}[chunkId] + ".chunk.js";
};